/**
 *
 * CartList
 *
 */

import React from "react";

import { Link } from "react-router-dom";
//import { Container, Row, Col } from 'reactstrap';

import Button from "../../Common/Button";
import { AiOutlineDelete } from "react-icons/ai";
import { FaMinus } from "react-icons/fa";
import { FaPlus } from "react-icons/fa";
import TextField from "@mui/material/TextField";
import { useMediaQuery } from "@mui/material";

const CartList = (props) => {
  const {
    cartItems,
    cartstyle,
    handleRemoveFromCart,
    handle_AddOneToCart,
    handle_RemoveOneFromCart,
    handle_itemDiscaunt,
    Edit,
  } = props;

  const { isEditPrice, isEditQty } = Edit;

  const isXSmall = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const handleProductClick = () => {
    props.toggleCart();
  };

  return (
    <div className="cart-list">
      {cartItems.map((item, index) => {
        if (!item.pricediscount) item.pricediscount = 0;
        //console.log(index);
        if (!cartstyle)
          return (
            <div key={index} className="item-box">
              <div className="item-details">
                <div
                //className="container"
                >
                  <div
                    className="mb-2 align-items-center row"
                    style={{
                      marginTop: -10,
                      borderBottom: "1px solid #a1887f",
                    }}
                  >
                    <div className="pr-0 ">
                      <h1 className="item-name ">
                        <span
                          className={"price fw-bold"}
                          style={{
                            marginLeft: 0,
                            marginRight: 10,
                          }}
                        >
                          {index + 1 + ")"}
                        </span>
                        <span className="price fw-bold">
                          {item.brand?.name + " / " + item.name}
                        </span>
                      </h1>
                    </div>
                  </div>
                  <div
                    className={"productInfo1"}
                    style={{
                      marginTop: 0,
                      marginBottom: isEditPrice || isEditQty ? -20 : 0,
                      marginLeft: isXSmall ? -10 : 0, //mob
                      //fontSize: "1.20rem",
                      width: isXSmall ? "115%" : "100%", //mob
                      //padding: 5,
                      display: "flex",
                      justifyContent: "space-between",
                      flexDirection: "row",
                      flexWrap: "nowrap",
                    }}
                  >
                    {!isEditPrice ? (
                      <>
                        <div className="fs-5">
                          <div className="d-flex">
                            <span
                              //className="price fw-bold"
                              className="price fw-bold  d-flex justify-content-center align-items-center"
                              style={{
                                marginLeft: 45,
                                marginTop: 5,
                                paddingRight: isXSmall ? "0.2rem" : "0.5rem",
                                paddingLeft: isXSmall ? "0.2rem" : "0.5rem",
                              }}
                            >
                              {item?.price?.toFixed(0) -
                                item?.pricediscount?.toFixed(0) +
                                "  "}
                            </span>
                            <span
                              className="price fw-bold"
                              style={{ marginLeft: 50, marginTop: 5 }}
                            >
                              грн.
                            </span>
                          </div>
                        </div>
                      </>
                    ) : (
                      <div className="fs-5">
                        <div className="d-flex">
                          <div
                            className="d-flex edit border border-1 py-1 px-2 fw-bold mb-3"
                            style={{
                              backgroundColor:
                                !item ||
                                (item?.pricediscount === 0
                                  ? "#00ff9f54" //f3fad1" //светло зеленый
                                  : item?.pricediscount > 0
                                  ? item?.pricediscount >= 50
                                    ? "#ff7c79" //темно красный
                                    : "#f6cccb" //светло красный
                                  : item?.pricediscount <= -50
                                  ? "#83bcf7" //темно зеленый
                                  : "#cbe0f6"), //светло зеленый
                            }}
                          >
                            <div
                              className={`px-2 minus d-flex justify-content-center align-items-center ${
                                item?.quantity > 2000
                                  ? "quantity-greater-than-two"
                                  : ""
                              }`}
                              onClick={() => {
                                //dispatch(removeOne(product?.id));
                                //handle_RemoveOneFromCart(item, { cartItems });
                                handle_itemDiscaunt(item, { cartItems }, 1);
                              }}
                            >
                              <FaMinus />
                            </div>
                            <span
                              //className="price fw-bold"
                              className="price fw-bold  d-flex justify-content-center align-items-center"
                              style={{
                                paddingRight: isXSmall ? "0.2rem" : "0.5rem",
                                paddingLeft: isXSmall ? "0.2rem" : "0.5rem",
                              }}
                            >
                              {item?.price?.toFixed(0) -
                                item?.pricediscount?.toFixed(0) +
                                "  "}
                            </span>

                            <div
                              className="px-2 plus d-flex justify-content-center align-items-center"
                              onClick={() => {
                                //dispatch(add(product));
                                //handle_AddOneToCart(item, { cartItems });
                                handle_itemDiscaunt(item, { cartItems }, -1);
                              }}
                            >
                              <FaPlus />
                            </div>
                          </div>
                          <span
                            className="price fw-bold"
                            style={{ marginLeft: 5, marginTop: 5 }}
                          >
                            грн.
                          </span>
                        </div>
                      </div>
                    )}

                    {!isEditQty ? (
                      <>
                        <div className="fs-5">
                          <span
                            // className="price fw-bold">
                            className="price fw-bold d-flex justify-content-center align-items-center"
                            style={{
                              marginTop: 5,
                              paddingRight: isXSmall ? "0.2rem" : "0.5rem",
                              paddingLeft: isXSmall ? "0.2rem" : "0.5rem",
                            }}
                          >
                            {item?.quantity || "0"}
                          </span>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="fs-5">
                          <div
                            className="d-flex edit border border-1 py-1 px-2 fw-bold mb-3"
                            style={{
                              backgroundColor: "#00ff9f54", //d6f6cb",
                              //    !item || item?.quantity === "0" ? "" : "#00ff9f54",
                            }}
                          >
                            <div
                              className={`px-2 minus d-flex justify-content-center align-items-center ${
                                item?.quantity < 2
                                  ? "quantity-greater-than-two"
                                  : ""
                              }`}
                              onClick={() => {
                                //dispatch(removeOne(product?.id));
                                handle_RemoveOneFromCart(item, { cartItems });
                              }}
                            >
                              <FaMinus />
                            </div>
                            <span
                              // className="price fw-bold">
                              className="price fw-bold d-flex justify-content-center align-items-center"
                              style={{
                                paddingRight: isXSmall ? "0.2rem" : "0.5rem",
                                paddingLeft: isXSmall ? "0.2rem" : "0.5rem",
                              }}
                            >
                              {item?.quantity || "0"}
                            </span>

                            <div
                              className="px-2 plus d-flex justify-content-center align-items-center"
                              onClick={() => {
                                //dispatch(add(product));
                                handle_AddOneToCart(item, { cartItems });
                              }}
                            >
                              <FaPlus />
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                    <div
                      className="fs-5"
                      style={{ marginTop: 5, marginRight: !isXSmall ? 0 : 26 }}
                    >
                      <span className="price fw-bold">
                        {item?.totalPrice?.toFixed(0) + "  "}
                      </span>
                      <span className="price  fw-bold">грн.</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        else
          return (
            <div key={index} className="item-box">
              <div className="item-details">
                <div className="container">
                  <div className="mb-2 align-items-center row">
                    <div className="pr-0 col-10">
                      <div className="d-flex align-items-center">
                        <img
                          className="item-image mr-2"
                          src={`${
                            item.thumbsURL
                              ? item.thumbsURL
                              : "/images/placeholder-image.png"
                          }`}
                        />

                        <div
                          //Link
                          //to={`/product/${item.slug}`}
                          className="item-link "
                          //onClick={handleProductClick}
                        >
                          <h1 className="item-name " style={{ marginLeft: 15 }}>
                            <span className="price fw-bold">{item.name}</span>
                          </h1>
                        </div>
                      </div>
                    </div>
                    <div xs="2" className="text-right col-1">
                      <button
                        type="button"
                        className="flex items-center  text-white py-1 px-2 rounded bg-blue-500"
                        //borderless
                        //variant="empty"
                        //ariaLabel={`remove ${item.name} from cart`}
                        //icon={<AiOutlineDelete />}
                        //<i className="icon-trash" aria-hidden="true" />}
                        onClick={() => {
                          //handle_RemoveFromCart(item, dispatch);
                          handleRemoveFromCart(item);
                        }}
                      >
                        <AiOutlineDelete />
                      </button>
                    </div>
                  </div>

                  <div
                    className={"productInfo1"}
                    style={{
                      marginTop: -10,
                      marginBottom: isEditPrice || isEditQty ? -25 : -5,
                      marginLeft: isXSmall ? -30 : 0, //mob
                      //fontSize: "1.20rem",
                      width: isXSmall ? "125%" : "100%", //mob
                      padding: 10,
                      display: "flex",
                      justifyContent: "space-between",
                      flexDirection: "row",
                      flexWrap: "nowrap",
                    }}
                  >
                    {!isEditPrice ? (
                      <>
                        <div className="fs-5">
                          <div className="d-flex">
                            <span
                              //className="price fw-bold"
                              className="price fw-bold  d-flex justify-content-center align-items-center"
                              style={{
                                marginLeft: 45,
                                marginTop: 5,
                                paddingRight: "0.5rem",
                                paddingLeft: "0.5rem",
                              }}
                            >
                              {item?.price?.toFixed(0) -
                                item?.pricediscount?.toFixed(0) +
                                "  "}
                            </span>
                            <span
                              className="price fw-bold"
                              style={{ marginLeft: 50, marginTop: 5 }}
                            >
                              грн.
                            </span>
                          </div>
                        </div>
                      </>
                    ) : (
                      <div className="fs-5">
                        <div className="d-flex">
                          <div
                            className="d-flex edit border border-1 py-1 px-2 fw-bold mb-3"
                            style={{
                              backgroundColor:
                                !item ||
                                (item?.pricediscount === 0
                                  ? "#00ff9f54" //f3fad1" //светло зеленый
                                  : item?.pricediscount > 0
                                  ? item?.pricediscount >= 50
                                    ? "#ff7c79" //темно красный
                                    : "#f6cccb" //светло красный
                                  : item?.pricediscount <= -50
                                  ? "#83bcf7" //темно зеленый
                                  : "#cbe0f6"), //светло зеленый
                            }}
                          >
                            <div
                              className={`px-2 minus d-flex justify-content-center align-items-center ${
                                item?.quantity > 2000
                                  ? "quantity-greater-than-two"
                                  : ""
                              }`}
                              onClick={() => {
                                //dispatch(removeOne(product?.id));
                                //handle_RemoveOneFromCart(item, { cartItems });
                                handle_itemDiscaunt(item, { cartItems }, 1);
                              }}
                            >
                              <FaMinus />
                            </div>
                            <span
                              //className="price fw-bold"
                              className="price fw-bold  d-flex justify-content-center align-items-center"
                              style={{
                                paddingRight: "0.5rem",
                                paddingLeft: "0.5rem",
                              }}
                            >
                              {item?.price?.toFixed(0) -
                                item?.pricediscount?.toFixed(0) +
                                "  "}
                            </span>

                            <div
                              className="px-2 plus d-flex justify-content-center align-items-center"
                              onClick={() => {
                                //dispatch(add(product));
                                //handle_AddOneToCart(item, { cartItems });
                                handle_itemDiscaunt(item, { cartItems }, -1);
                              }}
                            >
                              <FaPlus />
                            </div>
                          </div>
                          <span
                            className="price fw-bold"
                            style={{ marginLeft: 5, marginTop: 5 }}
                          >
                            грн.
                          </span>
                        </div>
                      </div>
                    )}

                    {!isEditQty ? (
                      <>
                        <div className="fs-5">
                          <span
                            // className="price fw-bold">
                            className="price fw-bold d-flex justify-content-center align-items-center"
                            style={{
                              marginTop: 5,
                              paddingRight: "0.5rem",
                              paddingLeft: "0.5rem",
                            }}
                          >
                            {item?.quantity || "0"}
                          </span>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="fs-5">
                          <div
                            className="d-flex edit border border-1 py-1 px-2 fw-bold mb-3"
                            style={{
                              backgroundColor: "#00ff9f54", //d6f6cb",
                              //    !item || item?.quantity === "0" ? "" : "#00ff9f54",
                            }}
                          >
                            <div
                              className={`px-2 minus d-flex justify-content-center align-items-center ${
                                item?.quantity < 2
                                  ? "quantity-greater-than-two"
                                  : ""
                              }`}
                              onClick={() => {
                                //dispatch(removeOne(product?.id));
                                handle_RemoveOneFromCart(item, { cartItems });
                              }}
                            >
                              <FaMinus />
                            </div>
                            <span
                              // className="price fw-bold">
                              className="price fw-bold d-flex justify-content-center align-items-center"
                              style={{
                                paddingRight: "0.5rem",
                                paddingLeft: "0.5rem",
                              }}
                            >
                              {item?.quantity || "0"}
                            </span>

                            <div
                              className="px-2 plus d-flex justify-content-center align-items-center"
                              onClick={() => {
                                //dispatch(add(product));
                                handle_AddOneToCart(item, { cartItems });
                              }}
                            >
                              <FaPlus />
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                    <div
                      className="fs-5"
                      style={{ marginTop: 5, marginLeft: 0, marginRight: 18 }}
                    >
                      <span className="price fw-bold">
                        {item?.totalPrice?.toFixed(0) + "  "}
                      </span>
                      <span className="price  fw-bold">грн.</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
      })}
    </div>
  );
};

export default CartList;
